import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'

export type SearchFormT = {
    keyword: string
    statusID: string[]
}

export type TransT = {
    th: string
    en: string
}

export type ResponseT = {
    userID: string
    name: TransT
    registerDate: string
    status: {
        id: string
        name: TransT
    }
}

const useExternalResearcher = () => {
    const callApi = useCallApi()
    const get = async (values: SearchFormT) => {
        const { data } = await callApi.axiosPost<{ result: ResponseT[] }>({
            url: umServinceURL.getExternalResearcher,
            params: values,
        })

        return data
    }

    return { get }
}

export default useExternalResearcher
